const WellnessCalendarUtilizationCard = ({ title = '', date = '', time = '', liner = '', classes = '', svgsrc }) => {
  return (
    <div
      className={
        'inline-flex flex-row items-center overflow-hidden rounded-lg border border-gray-250 bg-white shadow-sm transition-shadow duration-200 hover:shadow-md ' +
        classes
      }
    >
      <img src={svgsrc} className='h-full w-48 shrink-0 wellness-calendar-bronken' alt='' />
      <div className='flex min-w-0 flex-col px-4 py-3'>
        <h2 className='mb-0 text-base font-semibold leading-snug text-gray-800' style={{ lineHeight: 1.3 }}>
          {title}
        </h2>
        <p className='mb-0 mt-1 text-xs font-medium text-gray-600'>{`${date} · ${time}`}</p>
        <p className='mb-0 mt-1.5 text-xs leading-relaxed text-gray-500'>{liner}</p>
      </div>
    </div>
  );
};

export default WellnessCalendarUtilizationCard